// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__wFwao","myModalContent":"MyModal_myModalContent__6e7dp","active":"MyModal_active__83h50"};